import DateGlyph from './date.svg'
import GolfFieldGlyph from './golfField.svg'
import LocationGlyph from './location.svg'
import PresenterGlyph from './presenter.svg'

export { DateGlyph, GolfFieldGlyph, LocationGlyph, PresenterGlyph }
